import { http } from "./config";
import authHeader from "./auth-header";

const withAuth = (config = {}) => ({
  headers: authHeader(),
  ...config,
});

export default {
  listarAtendimentos(dataInicio, dataFim) {
    return http.get(
      "/api/atendimentos",
      withAuth({
        params: {
          dataInicio,
          dataFim,
        },
      }),
    );
  },

  buscarServicoFunerarioPorId(id) {
    return http.get(`/servico-funerario/${id}`, withAuth());
  },

  listarServicosFunerarios(dataInicio, dataFim) {
    return http.get(
      "/servico-funerario",
      withAuth({
        params: {
          dataInicio,
          dataFim,
        },
      }),
    );
  },

  buscarDocumentoAtendimento(idAtendimento, tipoDocumentoId) {
    return http.get(
      `/api/atendimentos/${idAtendimento}/documento/${tipoDocumentoId}`,
      withAuth(),
    );
  },
};
